import * as React from 'react'
import styles from './ctaBanner-style.css'
import Heading from '../Heading/Heading'
import Paragraph from '../Paragraph/Paragraph'
import Image from '../Image/Image'
import { CtaBannerViewModel } from './../../view-models/CtaBannerViewModel'
import CtaButton from '@/components/CtaButton/CtaButton'
import cx from 'classnames'
import Icon from '@/components/Icon/Icon'

 function CtaBanner({  
    image,
    heading,
    text,
    cta,
    theme = 'bank',
    appearance = 'light',
    illustration,
  }: CtaBannerViewModel) { 

  const event = cta ? 'cta' : ''
  const eventData = cta && cta.link ? cta.link.label : ''
  const eventMeta = {
    event,
    eventData,
  }

  return (
    <div
      className={cx(styles.ctaBanner, styles[theme], styles[appearance], {
        [styles.noImage]: !image,
      })}
    >
      <div className={styles.textWrapper}>
        {heading && (
          <Heading level={2} tag={'h2'} className={styles.ctaTitle}>
            {heading}
          </Heading>
        )}
        {text && (
          <Paragraph
            marginBottom={'none'}
            weight="light"
            className={styles.ctaText}
          >
            {text}
          </Paragraph>
        )}
        {cta && (
          <CtaButton
            {...cta}
            version={theme === 'bank' ? 1 : 2}
            withLinkArrow={false}
            darkBg={appearance === 'dark'}
            small
            eventMeta={eventMeta}
            className={styles.ctaButton}
          />
        )}
      </div>

      {image && (
        <Image
          {...image}
          width={264}
          height={264}
          className={styles.ctaImage}
        />
      )}

      {illustration && (
        <div className={styles.illustrationWrapper}>
          <Icon iconSrc={illustration} className={styles.bannerIllustration} />
        </div>
      )}
    </div>
  )
}

CtaBanner.displayName = 'CtaBanner'
CtaBanner.defaultProps = {}
export default CtaBanner
